/**
 * Quotation Service API
 * This is the quotation-service API generated by springdocs - a library for OpenAPI 3 with spring boot.
 *
 * The version of the OpenAPI document: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SelectOption } from './selectOption';


export interface SupplierDto { 
    id?: number;
    uid?: string;
    name?: string;
    displayName?: string;
    prefix?: string;
    vatNumber?: string;
    vatPercentage?: number;
    quotations?: Array<SelectOption>;
    contingency?: number;
    fee?: number;
    rating?: number;
    ratings?: number;
    pvGreenCardAccredited?: boolean;
    operationalSince?: string;
}

